/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { AptosCodeBlockInfo } from './AptosCodeBlockInfo';
import type { AptosCoinActionInfo } from './AptosCoinActionInfo';
import type { AptosFunctionSummaryInfo } from './AptosFunctionSummaryInfo';
import type { AptosGroupedCoinActionInfo } from './AptosGroupedCoinActionInfo';
import type { AptosGroupedNftActionInfo } from './AptosGroupedNftActionInfo';
import type { AptosNftActionInfo } from './AptosNftActionInfo';

export type AptosTrxOverviewInfo = {
    VER: string;
    TRXTP: AptosTrxOverviewInfo.TRXTP;
    TRXHA: string;
    AG: string;
    UT: number;
    STATTP: AptosTrxOverviewInfo.STATTP;
    FROM: string;
    FROMNN: string;
    FROMADDRTP: string;
    TO: string;
    TONN: string;
    TOADDRTP: string;
    AMT: string;
    FUNCSINFO: AptosFunctionSummaryInfo;
    BHE: string;
    SEQNO: string;
    EXAG: string;
    EXUT: number;
    GF: string;
    GU: string;
    GUP: string;
    MGL: string;
    VS: string;
    SIGCB: AptosCodeBlockInfo;
    SCH: string;
    ERH: string;
    ARH: string;
    FPADDR: string;
    SSADDR: Array<string>;
    NFTACT: Array<AptosNftActionInfo>;
    GRPNFTACT: Array<AptosGroupedNftActionInfo>;
    COINACT: Array<AptosCoinActionInfo>;
    GRPCOINACT: Array<AptosGroupedCoinActionInfo>;
    ID: string;
    EPC: string;
    RND: string;
    BGLR: AptosTrxOverviewInfo.BGLR;
    BOLR: AptosTrxOverviewInfo.BOLR;
    BEGU: string;
    BAOS: string;
};

export namespace AptosTrxOverviewInfo {

    export enum TRXTP {
        ALL = 'all',
        GENESIS_TRANSACTION = 'genesis_transaction',
        BLOCK_METADATA_TRANSACTION = 'block_metadata_transaction',
        USER_TRANSACTION = 'user_transaction',
        STATE_CHECKPOINT_TRANSACTION = 'state_checkpoint_transaction',
        VALIDATOR_TRANSACTION = 'validator_transaction',
        PENDING_TRANSACTION = 'pending_transaction',
        BLOCK_EPILOGUE_TRANSACTION = 'block_epilogue_transaction',
    }

    export enum STATTP {
        SUCCESS = 'SUCCESS',
        FAILURE = 'FAILURE',
        PENDING = 'PENDING',
        FAILED = 'FAILED',
        OUT_COMING = 'OUT_COMING',
        IN_COMING = 'IN_COMING',
        ALL = 'ALL',
    }

    export enum BGLR {
        Y = 'Y',
        N = 'N',
    }

    export enum BOLR {
        Y = 'Y',
        N = 'N',
    }


}

